import collab_max_allocation_in_proj from "./structs/collab_max_allocation_in_proj";
import max_percent_salary_in_apportionment from "./structs/max_percent_salary_in_apportionment";
import collab_allocation_in_proj from "./structs/collab_allocation_in_proj";
import collab_allocation_not_in_proj from "./structs/collab_allocation_not_in_proj";
import collab_order from "./structs/collab_order";
import project_order from "./structs/project_order";
import areas_per_project from "./structs/areas_per_project";
import collab_eligibility from "./structs/collab_eligibility";
import project_eligibility from "./structs/project_eligibility";

// Ordem de exibição corresponde ao index do array abaixo
export default [
  collab_max_allocation_in_proj,
  max_percent_salary_in_apportionment,
  collab_allocation_in_proj,
  collab_allocation_not_in_proj,
  collab_order,
  project_order,
  areas_per_project,
  collab_eligibility,
  project_eligibility
];